export default function dateFormat(): string {
  // return 'dd/MM/yyyy';
  return 'MM-dd-yyyy';
}
